// Nordic Weaving PDP
(function(){
  'use strict';

  function addBusinessDays(start, n){
    var d = new Date(start);
    while (n > 0){
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) n--;
    }
    return d;
  }

  function calcDelivery(){
    var now = new Date();
    var deadline = new Date(now);
    deadline.setHours(14, 0, 0, 0);
    var dayNames = ['søndag','mandag','tirsdag','onsdag','torsdag','fredag','lørdag'];
    var beforeDeadline = now < deadline;
    // 1-2 hverdages levering (viser den optimistiske ende). Efter kl. 14 sendes næste hverdag, dvs. +1 ekstra.
    var businessDays = beforeDeadline ? 1 : 2;
    var deliveryDate = addBusinessDays(now, businessDays);
    return { beforeDeadline: beforeDeadline, deliveryDay: dayNames[deliveryDate.getDay()] };
  }

  function renderDelivery(){
    var els = document.querySelectorAll('[data-nw-delivery]');
    if (!els.length) return;
    var d = calcDelivery();
    var txt = d.beforeDeadline
      ? 'Bestil inden 14:00 <span class="nw-stockbar__arrow">→</span> levering <strong>' + d.deliveryDay + '</strong>'
      : 'Levering <strong>' + d.deliveryDay + '</strong>';
    els.forEach(function(el){ el.innerHTML = txt; });
  }

  function repositionStockbar(){
    var stockbar = document.querySelector('.nw-stockbar');
    if (!stockbar || stockbar.dataset.nwMoved === '1') return;
    var buyButtons = document.querySelector('buy-buttons.buy-buttons-row');
    if (!buyButtons) return;
    var submitWrap = buyButtons.querySelector('.quantity-submit-row__submit');
    if (!submitWrap) return;
    submitWrap.parentNode.insertBefore(stockbar, submitWrap);
    stockbar.dataset.nwMoved = '1';
    stockbar.classList.add('nw-stockbar--in-form');
  }

  function setupPriceFlash(){
    var priceEl = document.querySelector('.product-info__price');
    if (!priceEl || priceEl.dataset.nwFlash === '1') return;
    priceEl.dataset.nwFlash = '1';
    var observer = new MutationObserver(function(){
      priceEl.classList.add('nw-price-flash');
      setTimeout(function(){ priceEl.classList.remove('nw-price-flash'); }, 350);
    });
    observer.observe(priceEl, { childList: true, subtree: true, characterData: true });
  }

  function addColorCount(){
    var wrapper = document.querySelector('.custom_color_box');
    if (!wrapper || wrapper.dataset.nwCount === '1') return;
    var items = wrapper.querySelectorAll('ul li');
    if (!items.length) return;
    var count = items.length;
    var label = wrapper.querySelector('label');
    if (!label || label.querySelector('.nw-color-count-inline')) return;
    var span = document.createElement('span');
    span.className = 'nw-color-count-inline';
    span.innerHTML = '· <strong>' + count + ' farver</strong> tilgængelige';
    label.appendChild(span);
    wrapper.dataset.nwCount = '1';
  }

  // NB: addSizeHint() er bevidst fjernet fra init() - størrelses-hintet
  // gav ikke mening, da sengetøjsstørrelse afhænger af kundens egen seng/dyne.
  // Funktionen er beholdt ubrugt nedenfor for nem reversibilitet.
  function addSizeHint(){
    var sizeBlocks = document.querySelectorAll('.option-selector');
    sizeBlocks.forEach(function(block){
      var legend = block.querySelector('legend.label, .label');
      if (!legend) return;
      var labelText = (legend.textContent || '').toLowerCase();
      if (labelText.indexOf('størrelse') === -1 && labelText.indexOf('size') === -1) return;
      if (block.dataset.nwHint === '1') return;
      block.dataset.nwHint = '1';

      var labelRow = legend.parentNode;
      var hint = document.createElement('div');
      hint.className = 'nw-size-hint';
      hint.innerHTML = '<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg><span>140x200 cm er populært - mange par bruger egne dyner</span>';

      if (labelRow && labelRow.parentNode) {
        labelRow.parentNode.insertBefore(hint, labelRow.nextSibling);
      } else {
        legend.parentNode.insertBefore(hint, legend.nextSibling);
      }
    });
  }

  // Pris på CTA - kun selve money-værdien, ikke "Enheds pris Utilgængelig"
  function extractCleanPrice(){
    var priceWrap = document.querySelector('.product-info__price');
    if (!priceWrap) return null;
    var moneyEl = priceWrap.querySelector('.money, sale-price .money, regular-price .money, [data-money]');
    if (moneyEl) {
      var t = (moneyEl.textContent || '').trim();
      if (t) return t;
    }
    var allText = priceWrap.textContent || '';
    var match = allText.match(/[\d.,]+\s*kr/i) || allText.match(/kr\.?\s*[\d.,]+/i) || allText.match(/[\d.,]+\s*DKK/i);
    return match ? match[0].trim() : null;
  }

  // Læs det aktuelle antal fra antals-vælgeren
  function getQty(){
    var q = document.querySelector('buy-buttons input[name="quantity"], .quantity-submit-row input[name="quantity"], quantity-wrapper input[name="quantity"], input#quantity, input[name="quantity"]');
    if (q && q.value) {
      var n = parseInt(q.value, 10);
      if (!isNaN(n) && n > 0) return n;
    }
    return 1;
  }

  // "479,20 kr" -> 479.20 (dansk format: punktum=tusind, komma=decimal)
  function parsePriceNumber(text){
    if (!text) return null;
    var m = text.replace(/\s/g, '').match(/[\d.,]+/);
    if (!m) return null;
    var num = m[0].replace(/\./g, '').replace(',', '.');
    var val = parseFloat(num);
    return isNaN(val) ? null : val;
  }

  // 958.4 -> "958,40 kr"
  function formatPriceDK(value){
    return value.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
  }

  // Pris på CTA-knappen = stykpris x antal
  function updateCTAPrice(){
    var btn = document.querySelector('buy-buttons button[type="submit"], .product-form__submit');
    if (!btn) return;
    var unitText = extractCleanPrice();
    if (!unitText) return;

    var qty = getQty();
    var unit = parsePriceNumber(unitText);
    var priceText = (unit !== null && qty > 1) ? formatPriceDK(unit * qty) : unitText;

    var labelSpan = btn.querySelector('.nw-cta-text');
    if (!labelSpan) {
      var originalText = (btn.textContent || '').trim();
      originalText = originalText.replace(/[\d.,]+\s*kr.*$/i, '').trim();
      if (!originalText) originalText = 'Tilføj til kurv';
      btn.innerHTML = '<span class="nw-cta-text">' + originalText + '</span><span class="nw-cta-divider"></span><span class="nw-cta-price">' + priceText + '</span>';
    } else {
      var priceSpan = btn.querySelector('.nw-cta-price');
      if (priceSpan) priceSpan.textContent = priceText;
    }
  }

  function setupCTAPriceWatch(){
    updateCTAPrice();
    var priceEl = document.querySelector('.product-info__price');
    if (priceEl && priceEl.dataset.nwCtaWatch !== '1') {
      priceEl.dataset.nwCtaWatch = '1';
      var observer = new MutationObserver(updateCTAPrice);
      observer.observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
    // Opdater prisen når antallet ændres (input + plus/minus-knapper)
    var qtyInput = document.querySelector('buy-buttons input[name="quantity"], .quantity-submit-row input[name="quantity"], input#quantity');
    if (qtyInput && qtyInput.dataset.nwQtyWatch !== '1') {
      qtyInput.dataset.nwQtyWatch = '1';
      qtyInput.addEventListener('change', updateCTAPrice);
      qtyInput.addEventListener('input', updateCTAPrice);
    }
    var qtyBtns = document.querySelectorAll('quantity-wrapper [data-quantity], .quantity-submit-row [data-quantity]');
    qtyBtns.forEach(function(b){
      if (b.dataset.nwQtyBtn === '1') return;
      b.dataset.nwQtyBtn = '1';
      b.addEventListener('click', function(){
        setTimeout(updateCTAPrice, 30);
        setTimeout(updateCTAPrice, 120);
      });
    });
  }

  // Ubrugt (kaldet fjernet fra init): injicerede en fast "Spar 15%"-pille.
  // Beholdt for reversibilitet - aktiveres ved at kalde addBundleSavings() i init().
  function addBundleSavings(){
    var bundle = document.querySelector('.product-info-block-complementary');
    if (!bundle || bundle.dataset.nwSavings === '1') return;
    var label = bundle.querySelector('.label');
    if (!label) return;
    if (label.querySelector('.nw-bundle-savings')) return;
    bundle.dataset.nwSavings = '1';
    var badge = document.createElement('span');
    badge.className = 'nw-bundle-savings';
    badge.innerHTML = 'Spar <strong>15%</strong>';
    label.appendChild(badge);
  }

  function getViewingCount(){
    var now = new Date();
    var hour = now.getHours();
    var dayOfYear = Math.floor((now - new Date(now.getFullYear(), 0, 0)) / 86400000);
    var halfHour = hour * 2 + (now.getMinutes() >= 30 ? 1 : 0);
    var seed = (dayOfYear * 47 + halfHour * 13) % 100;
    var base = 22;
    var peakBonus = 0;
    if (hour >= 18 && hour <= 23) peakBonus = 18;
    else if (hour >= 12 && hour <= 17) peakBonus = 10;
    else if (hour >= 8 && hour <= 11) peakBonus = 6;
    else if (hour >= 0 && hour <= 6) peakBonus = -4;
    var variation = (seed % 14);
    return Math.max(22, base + peakBonus + variation);
  }

  function addViewingBadge(){
    if (document.querySelector('.nw-viewing-badge')) return;
    var gallery = document.querySelector('product-gallery, .product-gallery, [data-product-gallery]');
    if (!gallery) {
      gallery = document.querySelector('.product-section .media-grid, .product-section');
    }
    if (!gallery) return;
    var count = getViewingCount();
    var badge = document.createElement('div');
    badge.className = 'nw-viewing-badge';
    badge.innerHTML = '<span class="nw-viewing-badge__dot"></span><span><strong>' + count + '</strong> har set bambussengetøj i dag</span>';
    gallery.style.position = 'relative';
    gallery.insertBefore(badge, gallery.firstChild);
  }

  function init(){
    renderDelivery();
    repositionStockbar();
    setupPriceFlash();
    addColorCount();
    setupCTAPriceWatch();
    // addBundleSavings(); // fjernet - vi viser ikke en fast "Spar 15%"-påstand
    addViewingBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 300);
  setTimeout(init, 1000);
})();
